export default __webpack_public_path__ + "assets/images/77cb2cbaa6064fbeddd7154754a36fcd.png";